export default function insertAtCaret(element: HTMLInputElement, text: string) {
  const strPos = element.selectionStart || 0;

  const front = element.value.substring(0, strPos);
  const back = element.value.substring(strPos, element.value.length);
  return front + text + back;
}
